import React, { FC } from 'react'
import classNames from 'classnames'
import moment from 'moment'
import {
  CalendarFormInput,
  ICalendarFormInputProps,
} from 'transfix-ui/components/CalendarFormInput'
import { Box } from 'transfix-ui/core'
import 'scss/5_components/_date-picker.scss'

interface IDateFilterProps {
  onChange: (value?: moment.Moment | null) => void
  value?: string | null
  onlyFutureDates?: boolean
}

/** Single date filter */
export const DateFilter: FC<IDateFilterProps> = ({ onChange, onlyFutureDates, value }) => {
  /**
   * Prevent current date from being highlighted in Mui's Datepicker when date value is null.
   * This was supposedly addressed in https://github.com/mui-org/material-ui/issues/24179 however it's still an issue.
   */
  const classes = classNames({
    'default-highlight': !value,
  })

  const dateHandler: ICalendarFormInputProps['onChange'] = date => {
    if (date && moment(date).isValid()) {
      onChange(moment(date))
    } else {
      onChange(null)
    }
  }

  const minDate = onlyFutureDates ? moment().toDate() : undefined

  return (
    <Box className={classes}>
      <CalendarFormInput value={value} onChange={dateHandler} minDate={minDate} />
    </Box>
  )
}
